/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TermOfUseAliases {
  FETCH_TERM_OF_USE = 'fetch-term-of-use',
  PANEL_TERM_OF_USE_MAIN = 'panel-term-of-use-main',
  TERM_SERVICE_TERM_OF_USE = 'term-service-term-of-use',
}
export { TermOfUseAliases };
